import React, {useMemo} from "react";
import {qrModules} from "../utils/qr";

const QUIET = 4; // the blank border readers need around a code, in squares

/**
 * A QR code for `value`, drawn as one SVG path: black on white whatever the
 * theme, so it scans (and prints) the same everywhere. It grows to its
 * container's width, or to `size` pixels when given.
 *
 * @param {{value: string, label?: string, size?: number}} props
 */
const QrCode = ({value, label = "QR code", size}) => {
    const modules = useMemo(() => qrModules(value), [value]);
    const total = modules.length + 2 * QUIET;
    const path = modules
        .flatMap((row, y) => row.map((dark, x) => (dark ? `M${x + QUIET} ${y + QUIET}h1v1h-1z` : "")))
        .join("");
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox={`0 0 ${total} ${total}`}
            width={size}
            height={size}
            style={size ? undefined : {width: "100%", height: "auto"}}
            shapeRendering="crispEdges"
            role="img"
            aria-label={label}
        >
            <rect width={total} height={total} fill="#fff" />
            <path d={path} fill="#000" />
        </svg>
    );
};

export default QrCode;
